import React from "react";
import { SwitchToggleProps } from "../../../interface/SwitchToggle";
import { LanguageTranslation } from "../../language-translation/LanguageTranslation";

function SwitchToggle({
  id,
  leftLabel,
  rightLabel,
  onChange,
  isChecked = false,
  disabled,
  withInnerText,
  langId = "fr", // Default language
  ...props
}: SwitchToggleProps) {
  const handleChange = async () => {
    if (onChange) await onChange(!isChecked);
  };

  // Get translations
  const followText = LanguageTranslation({ 
    labelName: "web_follow", 
    languageCode: langId 
  }) || "Follow";

  const followingText = LanguageTranslation({ 
    labelName: "web_following", 
    languageCode: langId 
  }) || "Following";

 

  return (
    <div className="flex items-center gap-3">
      {leftLabel && (
        <span className="text-base leading-6 font-semibold text-site-black">
          {leftLabel}
        </span>
      )}
      <label className="inline-flex items-center cursor-pointer" htmlFor={id}>
        <input
          type="checkbox"
          className="sr-only peer"
          onChange={handleChange}
          checked={isChecked}
          disabled={disabled}
        />
        <div
          className={`relative rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full after:content-[''] after:absolute after:bg-white after:rounded-full after:transition-all peer-checked:bg-site-yellow ${
            withInnerText
              ? "w-[94px] h-[26px] before:text-sm before:font-medium before:block before:absolute before:top-[4px] before:right-[30px] peer-checked:before:right-auto peer-checked:before:left-[10px] peer-checked:after:start-[56px] after:h-[16px] after:w-[16px] after:top-[5px] after:start-[6px] before:transition-all bg-site-yellow"
              : "w-[42px] h-[22px] peer-checked:after:start-[10px] after:h-[14px] after:w-[14px] after:top-[4px] after:start-[4px] bg-medium-grey"
          }`}
        >
          {withInnerText && (
            <span
              className={`absolute top-1/2 transform -translate-y-1/2 text-sm leading-[11px] font-medium text-[#121111] transition-[left,right] duration-300 ease-in-out z-10 ${
                isChecked ? "right-[28px]" : "left-[28px]"
              }`}
            >
              {isChecked ? followingText : followText}
            </span>
          )}
        </div>
      </label>
      {rightLabel && (
        <span className="text-base leading-6 font-normal text-dark-grey">
          {rightLabel}
        </span>
      )}
    </div>
  );
}

export default SwitchToggle;